/** Permission code constants - kept in lockstep with the backend's
 *  ``tilt_pos_api/permissions.py`` and the V0039/V0043 seeds.
 *
 *  Tests on the API side pin these strings, so a typo here surfaces
 *  as a never-matched gate rather than a failed contract. */

// ----- Profile (every authenticated user) ----- //
export const PROFILE_SELF_VIEW = "profile.self.view";
export const PROFILE_SELF_UPDATE = "profile.self.update";

// ----- Orders (V0043) ----- //
export const POS_ORDER_CREATE = "pos.order.create";
export const POS_ORDER_MODIFY = "pos.order.modify";
export const POS_ORDER_VOID = "pos.order.void";

// ----- Payments ----- //
export const POS_PAYMENT_INITIATE = "pos.payment.initiate";
export const POS_PAYMENT_REFUND = "pos.payment.refund";
export const POS_PAYMENT_REFUND_OWN = "pos.payment.refund_own";
export const POS_PAYMENT_VOID = "pos.payment.void";

// ----- Transactions ----- //
export const POS_TRANSACTION_VIEW = "pos.transaction.view";
export const POS_TRANSACTION_VIEW_OWN = "pos.transaction.view_own";
export const POS_TRANSACTION_EXPORT = "pos.transaction.export";
export const POS_TRANSACTION_VIEW_ALL_CHANNELS = "pos.transaction.view_all_channels";

// ----- Metrics + reporting ----- //
export const POS_METRICS_VIEW_LOCATION = "pos.metrics.view_location";
export const POS_METRICS_VIEW_ORG = "pos.metrics.view_org";
export const POS_METRICS_VIEW_PARTNER = "pos.metrics.view_partner";

// ----- Settings ----- //
export const POS_SETTINGS_LOCATION = "pos.settings.location";
export const POS_SETTINGS_BRAND = "pos.settings.brand";

// ----- AI ----- //
export const POS_AI_RECOMMENDATIONS_VIEW = "pos.ai.recommendations.view";
export const POS_AI_CHAT = "pos.ai.chat";

// ----- Kiosk ----- //
export const KIOSK_ORDER_HANDOFF_FROM_POS = "kiosk.order.handoff_from_pos";
